// This file contains API integration points for the login flow.
import { getApiUrl } from './config';
import logger from './utils/logger';

export async function apiCheckDbForUser(username) {
  try {
    const response = await fetch(getApiUrl('/api/check-user/'), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
      body: JSON.stringify({ username }),
    });

    if (!response.ok) {
      const errorData = await response.json();
      return { error: errorData.error || 'Failed to check user' };
    }

    const data = await response.json();
    return data;
  } catch (error) {
    logger.error('Error checking user:', error);
    return { error: 'Network error' };
  }
}

export async function apiValidatePassword(username, password) {
  try {
    const response = await fetch(getApiUrl('/api/auth/login/'), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
      body: JSON.stringify({ username, password }),
    });

    const data = await response.json();

    if (!response.ok) {
      return { success: false, error: data.error || 'Invalid credentials' };
    }

    return { success: data.success, jwt: data.jwt };
  } catch (error) {
    logger.error('Error validating password:', error);
    return { success: false, error: 'Network error' };
  }
}

// export async function apiRedirectToIdp(username) {
//   // TODO: Implement SSO redirect logic (e.g., Microsoft login)
//   // Should initiate redirect and handle callback
//   return { redirectUrl: 'https://login.microsoftonline.com/...' };
// }

// export async function apiValidateManifest(token) {
//   // Validate JWT token structure and signature client-side
//   // JWT tokens are cryptographically signed, so we can verify them with the public key

//   if (!token || typeof token !== 'string') {
//     return { valid: false, error: 'Invalid token format' };
//   }

//   // Check JWT structure (should have 3 parts separated by dots)
//   const parts = token.split('.');
//   if (parts.length !== 3) {
//     return { valid: false, error: 'Invalid JWT structure' };
//   }

//   try {
//     // Decode the payload (middle part)
//     const payload = JSON.parse(atob(parts[1]));

//     // Check if token is expired
//     if (payload.exp) {
//       const now = Math.floor(Date.now() / 1000);
//       if (payload.exp < now) {
//         return { valid: false, error: 'Token expired' };
//       }
//     }

//     // Check required fields
//     if (!payload.user_id || !payload.email) {
//       return { valid: false, error: 'Missing required fields' };
//     }

//     return { valid: true, payload };
//   } catch (error) {
//     return { valid: false, error: 'Failed to decode token' };
//   }
// }
